import { useEffect, useState } from 'react';

import { prepareFilter } from 'libs/common';
import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { BenefitTypeGrid } from './grid';
import BenefitTypeFilter from './filter';

export const BenefitType = (props) => {
  const [items, setItems] = useState({});
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('benefittypes', [{ field_name: 'id', direction: 'desc' }]);

  useEffect(() => {
    setItems({});
    return () => setItems({});
  }, [props.clientId]);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    const priceFields = ['min_amount', 'amount'];
    const addParams = { type: 'check' };
    if (props.clientId) {
      addParams.client_id = props.clientId;
    }
    return prepareFilter(data, addParams, { priceFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    clearEntries: () => setItems({}),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return <Controller {...props} {...gridParams} {...gridActions} type="benefit_types" filterName="benefit_typesFilter" grid={BenefitTypeGrid} gridFilter={BenefitTypeFilter} getRequestParams={prepareParams} />;
};
